// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c61e1ac","455":"1cb5df7e","977":"c0571d40"}[chunkId] + ".chunk.js";
};